import { autorun } from 'mobx';

import type { FormStore } from '../entities/form.entity';

import { FormPlugin } from './abstract-form-plugin.entity';

export class BlockPassingValuePlugin extends FormPlugin<FormStore> {
  connect(form: FormStore): VoidFunction | void {
    const passingValueField = form.fields['passingValue'];

    if (!passingValueField) {
      return;
    }

    return autorun(() => {
      const isVisuallyDisabledCommSpeedField = (() => {
        if (form.rigOperationsService.rigOperations.length > 1) {
          return true;
        }

        return form.rigOperationsService.rigOperations.some((r) => r.stages.some((s) => !!s.sections.length));
      })();

      passingValueField.setIsVisuallyDisabled({
        flagId: 'BlockPassingValuePlugin',
        value: isVisuallyDisabledCommSpeedField,
      });
    });
  }
}
